import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { CommonService } from "../services/common.service";
import { OnboardService } from "../services/onboard.service";
import { AuthGuard } from "../guard/auth.guard";

@Injectable({
  providedIn: 'root'
})
export class ShopGuard {
  constructor(
    public storage: StorageService,
    public router: Router,
    public commonService: CommonService,
    public onboardingservice: OnboardService,
    public authguard: AuthGuard
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const userData = this.commonService.getUserData();
    if (userData) {
      if (userData.shopId == null) {
        this.router.navigate(['/login']);
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}
